import React, { useState } from "react";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdChevronRight,
  MdKeyboardArrowDown,
  MdAddBox,
  MdIndeterminateCheckBox,
} from "react-icons/md";
import "./commonStyles.css";

const CheckboxTreeControl = (props) => {
  const { title, isError, menu, onChangeCall, selectedNodes } = props;
  const [checked, setChecked] = useState(selectedNodes ? selectedNodes : []);
  const [expandView, setExpandView] = useState(menu);

  const handleNodeCheck = (checked) => {
    setChecked(checked);
    onChangeCall(checked);
  };

  const icons = {
    check: <MdCheckBox className="rct-icon rct-icon-check" />,
    uncheck: <MdCheckBoxOutlineBlank className="rct-icon rct-icon-uncheck" />,
    halfCheck: (
      <MdIndeterminateCheckBox className="rct-icon rct-icon-half-check" />
    ),
    expandClose: <MdChevronRight className="rct-icon rct-icon-expand-close" />,
    expandOpen: (
      <MdKeyboardArrowDown className="rct-icon rct-icon-expand-open" />
    ),
    expandAll: <MdAddBox className="rct-icon rct-icon-expand-all" />,
    collapseAll: (
      <MdIndeterminateCheckBox className="rct-icon rct-icon-collapse-all" />
    ),
    // parentClose: <MdFolder className="rct-icon rct-icon-parent-close" />,
    // parentOpen: <MdFolderOpen className="rct-icon rct-icon-parent-open" />,
    // leaf: <MdInsertDriveFile className="rct-icon rct-icon-leaf-close" />,
    parentClose: null,
    parentOpen: null,
    leaf: null,
  };

  return (
    <div style={{ paddingLeft: "30px" }}>
      <div
        style={{ fontWeight: "bold" }}
        className={isError ? "inputLabelError" : ""}
      >
        {title}
      </div>
      <CheckboxTree
        nodes={menu}
        checked={checked}
        expanded={expandView}
        showExpandAll={true}
        onCheck={handleNodeCheck}
        onExpand={(expand) => setExpandView(expand)}
        icons={icons}
        expandAll={"Expand all"}
        collapseAll={"Collapse all"}
      />
    </div>
  );
};

export default CheckboxTreeControl;
